import { styled } from '@mui/system'
import Dialog from '../../molecules/dialog'
import Typography from '../../atoms/typography'

const DialogStyled = styled(Dialog)`
	.MuiPaper-root {
		padding: ${({ theme }) => theme.spacing(4)};
		${({ theme }) => theme.breakpoints.up('sm')} {
			padding: ${({ theme }) => theme.spacing(6)};
		}
	}
`

const TitleDialog = styled(Typography)`
	text-align: center;
	margin-top: ${({ theme }) => theme.spacing(3)};
	font-size: ${({ theme }) => theme.typography.pxToRem(28)};
	${({ theme }) => theme.breakpoints.up('sm')} {
		text-align: left;
		margin-top: 0;
	}
`
const DescriptionDialog = styled(Typography)`
	text-align: center;
	margin-bottom: ${({ theme }) => theme.spacing(2)};
	${({ theme }) => theme.breakpoints.up('sm')} {
		text-align: left;
		margin-bottom: ${({ theme }) => theme.spacing(5)};
	}
`

const RatingWrapper = styled('div')`
	text-align: center;
	margin-bottom: ${({ theme }) => theme.spacing(2)};
	${({ theme }) => theme.breakpoints.up('sm')} {
		text-align: left;
		margin-bottom: ${({ theme }) => theme.spacing(3)};
	}
`

export { DialogStyled, TitleDialog, DescriptionDialog, RatingWrapper }
